import { Injectable } from '@angular/core';
import { formatDateDocumento } from '../../helpers/formatDate';
import { Articolo, ArticoloFull } from '../../interfaces/custom/articolo';
import { StoreService } from '../store.service';

const STR_OPT_LIST = 'option_list';
const STR_OPT_CODE = 'option_code';

const option_disponibili = (num, articolo) => articolo['option_disponibili_' + num];

function getOptionPrice(data, key, options) {
  let OPTION_OBJ = {};
  options = options || {};  
  for (let i = 1; i <= 4; i++) {
    OPTION_OBJ['option_list_' + i] = data['option_list' + i] || 0;
    OPTION_OBJ['option_code_' + i] = options[i] || 0;
  }
  let listini = data['listini_opzioni'];
  let prezzo = listini.filter(l => {
    for (let i = 1; i <= 4; i++) {
      if (l['option_list_' + i] != OPTION_OBJ['option_list_' + i])
        return false;
      if (l['option_code_' + i] != OPTION_OBJ['option_code_' + i])
        return false;
    }
    return true;
  }).reduce((prev, curr) => curr[key] < prev ? curr[key] : prev, Infinity);

  return prezzo == Infinity ? -1 : prezzo;
}

@Injectable({
  providedIn: 'root'
})
export class PriceArticoloService {

  constructor(private store: StoreService) {
  }

  prezzoArticolo(articolo: Partial<ArticoloFull>, options?) {
    if (!options || Object.keys(options).length == 0)
      return articolo.prezzo;
    else {
      let basePrice = getOptionPrice(articolo, 'prezzo', options);
      if (basePrice == -1)
        return -1;
      let finalPrice = basePrice;
      for (let num of Object.keys(options)) {
        let progressivo = options[num];
        if (progressivo) {
          let option = option_disponibili(num, articolo).find(obj => obj.progressivo == progressivo);
          if (option && option.valore) {
            let diff = 0;
            if (!option.ind_per_ass)
              diff = basePrice * (option.valore / 100);
            else {
              if (this.store.price == 'b2b')
                diff = option.valore;
              else
                diff = option.valore * (1 + Number(articolo.aliquota) / 100);
            }
            if (option.ind_sco_mag)
              finalPrice += diff;
            else
              finalPrice -= diff;
          }
        }
      }

      return finalPrice;
    }
  }

  prezzoArticoloOld(articolo: Partial<ArticoloFull>, options?) {
    if (!options || Object.keys(options).length == 0)
      return articolo.prezzo_originale;
    else {
      let basePrice = getOptionPrice(articolo, 'prezzo_originale', options);
      if (basePrice == -1)
        return -1;
      let finalPrice = basePrice;
      for (let num of Object.keys(options)) {
        let progressivo = options[num];
        if (progressivo) {
          let option = option_disponibili(num, articolo).find(obj => obj.progressivo == progressivo);
          if (option && option.valore) {
            let diff = 0;
            if (!option.ind_per_ass)
              diff = basePrice * (option.valore / 100);
            else {
              if (this.store.price == 'b2b')
                diff = option.valore;
              else
                diff = option.valore * (1 + Number(articolo.aliquota) / 100);
            }
            if (option.ind_sco_mag)
              finalPrice += diff;
            else
              finalPrice -= diff;
          }
        }
      }
      
      return finalPrice;
    }
  }

  hasDiscount(articolo: Partial<ArticoloFull>) {
    return this.prezzoArticolo(articolo) < this.prezzoArticoloOld(articolo);
  }

  offertaEndDate(articolo : Partial<ArticoloFull>) {
    if (articolo.scadenza_promozionale.startsWith('2099'))
      return '';
    let end = new Date(articolo.scadenza_promozionale);
    return formatDateDocumento(end);
  }

  getOffertaPercent(articolo, options?) {
    let oldPrice = this.prezzoArticoloOld(articolo, options);
    let newPrice = this.prezzoArticolo(articolo, options);

    return Math.round((1 - newPrice / oldPrice) * 100);
  }

  priceOfAttributeSelected(articolo : Partial<ArticoloFull>) {
    let total = 0;
    if (articolo.attributi) {
      for (let attribute of articolo.attributi) {
        if (attribute.selected)
          total += Number(attribute.prezzo || 0);
      }
    }
    return total;
  }

}
